import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotTicker() {
  const items = [...articles].sort((a, b) => b.hot - a.hot).slice(0, 6);
  const loop = [...items, ...items];

  return (
    <section aria-label="实时热榜滚动" className="w-full border-y border-background-200 bg-foreground-950 py-3">
      <div className="flex w-full items-center gap-4 overflow-hidden px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-label text-background-50">
          <i className="ri-pulse-line" />
          实时热榜
        </span>
        <div className="min-w-0 flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8">
            {loop.map((a, i) => (
              <Link
                key={`${a.id}-${i}`}
                to={`/article/${a.id}`}
                className="flex shrink-0 items-center gap-2 whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
              >
                <span className="rounded-sm bg-background-50/10 px-1.5 py-0.5 text-[11px] text-accent-300">
                  {a.categoryName}
                </span>
                {a.title}
                <span className="text-xs text-background-400">热度 {a.hot}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}